exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toolbar-fixed[data-v-e63791dc]{position:-webkit-sticky;position:sticky;top:0;z-index:5}", ""]);

// exports
